import ApiClient from '@src/lib/api_client'
import { API } from '@src/lib/api_path'
import camelcaseKeys from 'camelcase-keys'
import ClassData from '@src/data/class'
import { DEFAULT_PAGE_SIZE } from '@src/util/constants'

type ClassesResponse = {
  club_classes: ClassData[],
  meta: {
    total_pages: number,
    content_types_counters: {},
    locales_counters: {}
  }
}

export class ClassService {

  apiClient: ApiClient = new ApiClient()

  getClasses (page: number, name: string, locale, types: string[]) {
    return this.apiClient.get<ClassesResponse>(API.TRAINERS_API.CLASSES,
      { page, name, locale: locale || undefined, content_types: types, items_per_page: DEFAULT_PAGE_SIZE }
      )
      .then((response: ClassesResponse) => {
        return Promise.resolve({
          classList: response.club_classes.map((item: any) => new ClassData(camelcaseKeys(item, { deep: true }))),
          contentTypeCounters: response.meta.content_types_counters,
          localesCounters: response.meta.locales_counters,
          totalPages: response.meta.total_pages
        })
      })
      .catch(error => {
        console.error('failed to retrieve classes', error)
        return Promise.reject(error)
      })
  }

  show (classId: number) {
    return this.apiClient.post(API.TRAINERS_API.CLASSES_SHOW.replace('{classId}', `${classId}`), {})
      .then(() => Promise.resolve())
      .catch(error => {
        console.error('failed to show class', error)
        return Promise.reject(error)
      })
  }

  hide (classId: number) {
    return this.apiClient.post(API.TRAINERS_API.CLASSES_HIDE.replace('{classId}', `${classId}`), {})
      .then(() => Promise.resolve())
      .catch(error => {
        console.error('failed to hide class', error)
        return Promise.reject(error)
      })
  }

  toggleClassVisibility (classId: number) {
    let path = API.TRAINERS_API.CLASSES_TOGGLE_HIDDEN.replace('{classId}', `${classId}`)
    return this.apiClient.post(path, {})
      .then(() => Promise.resolve())
      .catch(error => {
        console.log('cannot edit class', error)
        return Promise.reject(error)
      })
  }
}
